export class PhotoService {

  public resource: ng.resource.IResourceClass<ng.resource.IResource<any>>;

  constructor(private $resource: ng.resource.IResourceService) {
    this.resource = $resource('api/customers/:customerId/photos/:photoId',
      undefined, <any>{
        save: { method: 'POST', transformRequest: angular.identity, headers: { 'Content-Type': undefined } },
        get: {
          responseType: 'arraybuffer', transformResponse: (data: any) => {
            // Stores the ArrayBuffer object in a property called "data"
            return { data: data };
          }
        },
        edit: { method: 'PATCH' },
        update: { method: 'PUT' }
      }
    );
  }

  public create(customerId: string, data: any, name: string) {
    const formData = new FormData();
    formData.append('file', data, name);
    return this.resource.save({ customerId: customerId }, formData).$promise;
  }

  public getCustomerPhoto(customerId: string, photoId: string) {
    return this.resource.get({ customerId: customerId, photoId: photoId }).$promise.then((resource) => {
      return resource.data;
    });
  }
}